// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 23 hooks for backend/separations.

import { useBackend } from '../useBackend'

/** POST /api/separations/attachSeparationInspection */
export function useAttachSeparationInspection<T = any>() {
  return useBackend<T>('separations/attachSeparationInspection')
}

/** POST /api/separations/checkSeparationSources */
export function useCheckSeparationSources<T = any>() {
  return useBackend<T>('separations/checkSeparationSources')
}

/** POST /api/separations/closeSeparation */
export function useCloseSeparation<T = any>() {
  return useBackend<T>('separations/closeSeparation')
}

/** POST /api/separations/computeSeparation */
export function useComputeSeparation<T = any>() {
  return useBackend<T>('separations/computeSeparation')
}

/** POST /api/separations/decideSeparationApprover */
export function useDecideSeparationApprover<T = any>() {
  return useBackend<T>('separations/decideSeparationApprover')
}

/** POST /api/separations/decideSeparationStep */
export function useDecideSeparationStep<T = any>() {
  return useBackend<T>('separations/decideSeparationStep')
}

/** POST /api/separations/deliverSeparation */
export function useDeliverSeparation<T = any>() {
  return useBackend<T>('separations/deliverSeparation')
}

/** POST /api/separations/getSeparation */
export function useGetSeparation<T = any>() {
  return useBackend<T>('separations/getSeparation')
}

/** POST /api/separations/getSeparationSettings */
export function useGetSeparationSettings<T = any>() {
  return useBackend<T>('separations/getSeparationSettings')
}

/** POST /api/separations/getSeparations */
export function useGetSeparations<T = any>() {
  return useBackend<T>('separations/getSeparations')
}

/** POST /api/separations/issueSeparation */
export function useIssueSeparation<T = any>() {
  return useBackend<T>('separations/issueSeparation')
}

/** POST /api/separations/openSeparation */
export function useOpenSeparation<T = any>() {
  return useBackend<T>('separations/openSeparation')
}

/** POST /api/separations/openSeparationDocument */
export function useOpenSeparationDocument<T = any>() {
  return useBackend<T>('separations/openSeparationDocument')
}

/** POST /api/separations/readSeparationLeave */
export function useReadSeparationLeave<T = any>() {
  return useBackend<T>('separations/readSeparationLeave')
}

/** POST /api/separations/reassignSeparationStep */
export function useReassignSeparationStep<T = any>() {
  return useBackend<T>('separations/reassignSeparationStep')
}

/** POST /api/separations/recordSeparationArrears */
export function useRecordSeparationArrears<T = any>() {
  return useBackend<T>('separations/recordSeparationArrears')
}

/** POST /api/separations/recordSeparationCash */
export function useRecordSeparationCash<T = any>() {
  return useBackend<T>('separations/recordSeparationCash')
}

/** POST /api/separations/recordSeparationUi19Told */
export function useRecordSeparationUi19Told<T = any>() {
  return useBackend<T>('separations/recordSeparationUi19Told')
}

/** POST /api/separations/reopenSeparation */
export function useReopenSeparation<T = any>() {
  return useBackend<T>('separations/reopenSeparation')
}

/** POST /api/separations/sendSeparationForSignature */
export function useSendSeparationForSignature<T = any>() {
  return useBackend<T>('separations/sendSeparationForSignature')
}

/** POST /api/separations/syncSeparationSignatures */
export function useSyncSeparationSignatures<T = any>() {
  return useBackend<T>('separations/syncSeparationSignatures')
}

/** POST /api/separations/updateSeparation */
export function useUpdateSeparation<T = any>() {
  return useBackend<T>('separations/updateSeparation')
}

/** POST /api/separations/updateSeparationSettings */
export function useUpdateSeparationSettings<T = any>() {
  return useBackend<T>('separations/updateSeparationSettings')
}
